{
	"requests_one": "Attention! You have {{value}} pending vendor withdrawal requests",
	"requests_other": "Attention! You have {{value}} pending vendor withdrawal requests",
	"isApproved": "Attention! This location is in pre-approval status, it will not be possible to open events until approval is made.",
	"certificatesAboutToExpire": "Digital certificates for {{value}} tax profiles will expire in less than 30 days!",
	"expiredCertificates": "The digital certificates for the {{value}} fiscal profiles have expired!",
	"blockedPlace": "The place {{placeName}} is blocked",
	"blockedPlaces": "The places {{placeName}} are blocked"
}
